import { createContentPropTypes } from '../../helpers/content';

const paymentReviewContent = {
	noAvailableAuthorisersErrorMessage:
		'Sorry, there aren’t enough users with the correct permissions to authorise this payment.',
};

export const contentPropTypes = createContentPropTypes(paymentReviewContent);

export { paymentReviewContent };
